(function () {
    // Prevent double-init when theme loads the asset twice
    if (window.__SKIN_ANALYSIS_JS_LOADED__) return
    window.__SKIN_ANALYSIS_JS_LOADED__ = true

    var ROTATION_KEY = 'skin_analysis_rotation'
    var MAX_BYTES = 8 * 1024 * 1024 // 8 MB

    function ready(fn) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn)
        } else {
            fn()
        }
    }

    ready(function () {
        var root = document.querySelector('[data-skin-analysis]')
        if (!root || root.__skinAnalysisBound) return
        root.__skinAnalysisBound = true

        var els = {
            tabs: root.querySelectorAll('[data-mode-tab]'),
            panels: {
                upload: root.querySelector('[data-panel="upload"]'),
                camera: root.querySelector('[data-panel="camera"]')
            },
            fileInput: root.querySelector('[data-file-input]'),
            video: root.querySelector('[data-video]'),
            videoWrap: root.querySelector('[data-video-wrap]'),
            cameraIdle: root.querySelector('[data-camera-idle]'),
            cameraMsg: root.querySelector('[data-camera-msg]'),
            startCamera: root.querySelector('[data-start-camera]'),
            capturePhoto: root.querySelector('[data-capture-photo]'),
            flipCamera: root.querySelector('[data-flip-camera]'),
            stopCamera: root.querySelector('[data-stop-camera]'),
            previewWrap: root.querySelector('[data-preview-wrap]'),
            preview: root.querySelector('[data-preview]'),
            rotateLeft: root.querySelector('[data-rotate-left]'),
            rotateRight: root.querySelector('[data-rotate-right]'),
            clearImage: root.querySelector('[data-clear-image]'),
            rotationLabel: root.querySelector('[data-rotation-label]'),
            workCanvas: root.querySelector('[data-work-canvas]'),
            analyzeBtn: root.querySelector('[data-analyze-btn]'),
            status: root.querySelector('[data-status]'),
            output: root.querySelector('[data-output]'),
            error: root.querySelector('[data-error]'),
            notes: root.querySelector('[data-notes]')
        }

        var state = {
            mode: 'upload',
            sourceBlob: null,
            rotation: loadRotation(),
            stream: null,
            facingMode: 'user',
            objectUrl: null,
            previewUrl: null,
            starting: false,
            startToken: 0
        }

        /* ---------------- Helpers ---------------- */

        function loadRotation() {
            var n = Number(sessionStorage.getItem(ROTATION_KEY))
            return [0, 90, 180, 270].indexOf(n) !== -1 ? n : 0
        }

        function saveRotation() {
            sessionStorage.setItem(ROTATION_KEY, String(state.rotation))
            if (els.rotationLabel) els.rotationLabel.textContent = state.rotation + '°'
        }

        function setStatus(text) {
            if (els.status) els.status.textContent = text || ''
        }

        function showError(message) {
            if (!els.error) return
            els.error.textContent = message
            els.error.classList.remove('is-hidden')
        }

        function clearError() {
            if (!els.error) return
            els.error.textContent = ''
            els.error.classList.add('is-hidden')
        }

        function revokeObjectUrl() {
            if (state.objectUrl) {
                URL.revokeObjectURL(state.objectUrl)
                state.objectUrl = null
            }
        }

        function revokePreviewUrl() {
            if (state.previewUrl) {
                URL.revokeObjectURL(state.previewUrl)
                state.previewUrl = null
            }
        }

        function getBrowserId() {
            var key = 'skin_browser_id'
            var id = localStorage.getItem(key)
            if (!id) {
                id =
                    (window.crypto && crypto.randomUUID && crypto.randomUUID()) ||
                    'b_' + Date.now() + '_' + Math.random().toString(16).slice(2)
                localStorage.setItem(key, id)
            }
            return id
        }

        function getSessionId() {
            var key = 'skin_session_id'
            var id = sessionStorage.getItem(key)
            if (!id) {
                id =
                    (window.crypto && crypto.randomUUID && crypto.randomUUID()) ||
                    's_' + Date.now() + '_' + Math.random().toString(16).slice(2)
                sessionStorage.setItem(key, id)
            }
            return id
        }

        function getApiConfig() {
            return {
                baseUrl: (root.getAttribute('data-api-url') || '').replace(/\/$/, ''),
                token: root.getAttribute('data-api-token') || '',
                mode: root.getAttribute('data-api-mode') || 'json'
            }
        }

        function getNotes() {
            if (!els.notes) return ''
            return (els.notes.value || '').trim()
        }

        /* ---------------- Mode / image ---------------- */

        function setMode(mode) {
            state.mode = mode
            els.tabs.forEach(function (tab) {
                var active = tab.getAttribute('data-mode-tab') === mode
                tab.classList.toggle('is-active', active)
                tab.setAttribute('aria-selected', active ? 'true' : 'false')
            })
            if (els.panels.upload) {
                els.panels.upload.classList.toggle('is-hidden', mode !== 'upload')
            }
            if (els.panels.camera) {
                els.panels.camera.classList.toggle('is-hidden', mode !== 'camera')
            }
            if (mode !== 'camera') stopCamera()
        }

        function setSourceBlob(blob) {
            if (!blob) return
            if (blob.size > MAX_BYTES) {
                showError('Image is too large. Please use a file under 8 MB.')
                return
            }
            clearError()
            state.sourceBlob = blob
            revokeObjectUrl()
            state.objectUrl = URL.createObjectURL(blob)
            if (els.previewWrap) els.previewWrap.classList.remove('is-hidden')
            if (els.analyzeBtn) els.analyzeBtn.disabled = false
            renderPreview()
            setStatus('Photo ready. Rotate if needed, then analyze.')
        }

        function getFinalImageBlob() {
            return new Promise(function (resolve, reject) {
                if (!state.sourceBlob || !state.objectUrl) {
                    reject(new Error('No image selected.'))
                    return
                }

                var img = new Image()
                img.onload = function () {
                    var angle = state.rotation % 360
                    var rad = (angle * Math.PI) / 180
                    var swap = angle === 90 || angle === 270
                    var srcW = img.naturalWidth
                    var srcH = img.naturalHeight
                    var canvas = els.workCanvas

                    if (!canvas) {
                        reject(new Error('Work canvas missing from page.'))
                        return
                    }

                    canvas.width = swap ? srcH : srcW
                    canvas.height = swap ? srcW : srcH

                    var ctx = canvas.getContext('2d')
                    ctx.save()
                    ctx.translate(canvas.width / 2, canvas.height / 2)
                    ctx.rotate(rad)
                    ctx.drawImage(img, -srcW / 2, -srcH / 2)
                    ctx.restore()

                    canvas.toBlob(
                        function (blob) {
                            if (!blob) {
                                reject(new Error('Could not export rotated image.'))
                                return
                            }
                            resolve(blob)
                        },
                        'image/jpeg',
                        0.92
                    )
                }
                img.onerror = function () {
                    reject(new Error('Could not read image for rotation.'))
                }
                img.src = state.objectUrl
            })
        }

        function renderPreview() {
            getFinalImageBlob()
                .then(function (blob) {
                    revokePreviewUrl()
                    state.previewUrl = URL.createObjectURL(blob)
                    if (els.preview) els.preview.src = state.previewUrl
                    saveRotation()
                })
                .catch(function (err) {
                    showError(err.message || 'Preview failed.')
                })
        }

        function clearImage() {
            state.sourceBlob = null
            revokeObjectUrl()
            revokePreviewUrl()
            if (els.preview) els.preview.removeAttribute('src')
            if (els.previewWrap) els.previewWrap.classList.add('is-hidden')
            if (els.analyzeBtn) els.analyzeBtn.disabled = true
            if (els.fileInput) els.fileInput.value = ''
            setStatus('')
            clearError()
        }

        function rotate(delta) {
            if (!state.sourceBlob) return
            state.rotation = (state.rotation + delta + 360) % 360
            saveRotation()
            renderPreview()
        }

        /* ---------------- Upload ---------------- */

        if (els.fileInput) {
            els.fileInput.addEventListener('change', function () {
                var file = els.fileInput.files && els.fileInput.files[0]
                if (!file) return
                if (!file.type || file.type.indexOf('image/') !== 0) {
                    showError('Please choose an image file.')
                    return
                }
                setSourceBlob(file)
            })
        }

        /* ---------------- Camera ---------------- */

        function cameraSupported() {
            return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)
        }

        function showCameraMessage(msg) {
            if (!els.cameraMsg) return
            els.cameraMsg.textContent = msg
            els.cameraMsg.classList.remove('is-hidden')
        }

        function hideCameraMessage() {
            if (!els.cameraMsg) return
            els.cameraMsg.textContent = ''
            els.cameraMsg.classList.add('is-hidden')
        }

        function setCameraControls(active) {
            if (els.capturePhoto) els.capturePhoto.disabled = !active
            if (els.flipCamera) els.flipCamera.disabled = !active
            if (els.stopCamera) els.stopCamera.disabled = !active
            if (els.startCamera) els.startCamera.disabled = !!active || state.starting
            if (els.videoWrap) els.videoWrap.classList.toggle('is-live', !!active)
        }

        function prepareVideoElement() {
            if (!els.video) return
            els.video.setAttribute('playsinline', 'true')
            els.video.setAttribute('webkit-playsinline', 'true')
            els.video.setAttribute('muted', 'true')
            els.video.muted = true
            els.video.autoplay = true
            els.video.playsInline = true
        }

        function buildConstraintAttempts(facingMode) {
            return [
                { audio: false, video: true },
                { audio: false, video: { facingMode: facingMode } },
                {
                    audio: false,
                    video: {
                        facingMode: { ideal: facingMode },
                        width: { ideal: 1280 },
                        height: { ideal: 1280 }
                    }
                }
            ]
        }

        function getStreamWithFallback(facingMode) {
            var attempts = buildConstraintAttempts(facingMode)
            var i = 0

            function next() {
                if (i >= attempts.length) {
                    return Promise.reject(new Error('No camera constraints succeeded.'))
                }
                var constraints = attempts[i++]
                return navigator.mediaDevices.getUserMedia(constraints).catch(function (err) {
                    if (i >= attempts.length) throw err
                    return next()
                })
            }

            return next()
        }

        function waitForVideoReady(video) {
            return new Promise(function (resolve, reject) {
                if (!video) {
                    reject(new Error('Video element missing.'))
                    return
                }
                if (video.videoWidth > 0 && video.videoHeight > 0) {
                    resolve()
                    return
                }

                var settled = false
                var timer = setTimeout(function () {
                    if (settled) return
                    settled = true
                    cleanup()
                    if (video.videoWidth > 0) resolve()
                    else reject(new Error('Camera timed out waiting for video frames.'))
                }, 4000)

                function cleanup() {
                    clearTimeout(timer)
                    video.removeEventListener('loadedmetadata', onLoaded)
                    video.removeEventListener('error', onError)
                }

                function onLoaded() {
                    if (settled) return
                    settled = true
                    cleanup()
                    if (video.videoWidth > 0) resolve()
                    else reject(new Error('Camera started but video has no dimensions.'))
                }

                function onError() {
                    if (settled) return
                    settled = true
                    cleanup()
                    reject(new Error('Video failed to load camera stream.'))
                }

                video.addEventListener('loadedmetadata', onLoaded)
                video.addEventListener('error', onError)
            })
        }

        function stopCamera() {
            state.startToken += 1
            state.starting = false

            if (state.stream) {
                state.stream.getTracks().forEach(function (track) {
                    track.stop()
                })
                state.stream = null
            }
            if (els.video) els.video.srcObject = null
            setCameraControls(false)
        }

        function startCamera() {
            clearError()
            hideCameraMessage()

            if (state.starting) return

            if (!window.isSecureContext) {
                showCameraMessage('Camera requires HTTPS. Open your live Shopify shop URL.')
                return
            }

            if (!cameraSupported()) {
                showCameraMessage(
                    'Camera API not available. Use Upload, or open in Safari (iOS) / Chrome (Android).'
                )
                setMode('upload')
                return
            }

            if (!els.video || !els.panels.camera) {
                showCameraMessage('Camera UI is missing from the page.')
                return
            }

            els.panels.camera.classList.remove('is-hidden')

            if (state.stream) {
                state.stream.getTracks().forEach(function (track) {
                    track.stop()
                })
                state.stream = null
            }
            if (els.video) els.video.srcObject = null

            prepareVideoElement()
            state.starting = true
            var myToken = ++state.startToken
            setCameraControls(false)
            if (els.startCamera) els.startCamera.disabled = true
            setStatus('Requesting camera permission…')

            getStreamWithFallback(state.facingMode)
                .then(function (stream) {
                    if (myToken !== state.startToken) {
                        stream.getTracks().forEach(function (t) {
                            t.stop()
                        })
                        var cancelled = new Error('Camera start cancelled.')
                        cancelled.name = 'AbortError'
                        throw cancelled
                    }

                    state.stream = stream
                    els.video.srcObject = stream

                    var playPromise = els.video.play()
                    if (playPromise && typeof playPromise.then === 'function') {
                        return playPromise.then(function () {
                            return waitForVideoReady(els.video)
                        })
                    }
                    return waitForVideoReady(els.video)
                })
                .then(function () {
                    if (myToken !== state.startToken) return
                    state.starting = false
                    setCameraControls(true)
                    hideCameraMessage()
                    setStatus(
                        'Camera ready (' +
                        els.video.videoWidth +
                        '×' +
                        els.video.videoHeight +
                        '). Tap Capture.'
                    )
                })
                .catch(function (err) {
                    if (myToken !== state.startToken) return

                    state.starting = false
                    setCameraControls(false)

                    if (state.stream) {
                        state.stream.getTracks().forEach(function (t) {
                            t.stop()
                        })
                        state.stream = null
                    }
                    if (els.video) els.video.srcObject = null

                    var name = (err && err.name) || ''
                    var message = (err && err.message) || ''

                    if (name === 'NotAllowedError' || name === 'PermissionDeniedError') {
                        showCameraMessage(
                            'Permission denied. Allow Camera for this site, then tap Start camera again. Or use Upload.'
                        )
                    } else if (name === 'NotFoundError' || name === 'DevicesNotFoundError') {
                        showCameraMessage('No camera found on this device. Use Upload.')
                    } else if (name === 'NotReadableError' || name === 'TrackStartError') {
                        showCameraMessage('Camera is in use by another app. Close it and try again.')
                    } else if (name === 'OverconstrainedError') {
                        showCameraMessage(
                            'This camera mode is not supported. Try Flip camera, or use Upload.'
                        )
                    } else if (name === 'AbortError') {
                        showCameraMessage(
                            'Camera was interrupted (AbortError). Make sure skin-analysis.js loads only once, then tap Start camera again. Or use Upload.'
                        )
                    } else {
                        showCameraMessage(
                            'Could not start camera' +
                            (name ? ' (' + name + ')' : '') +
                            (message ? ': ' + message : '') +
                            '. Use Upload, or try Safari/Chrome.'
                        )
                    }

                    setStatus('Camera failed')
                    console.warn('getUserMedia failed', err)
                })
        }

        function captureFromVideo() {
            clearError()
            if (!state.stream) {
                showError('Start the camera first.')
                return
            }

            var video = els.video
            if (!video || !video.videoWidth || !video.videoHeight) {
                showError('Camera is not ready yet. Wait a second and try Capture again.')
                return
            }

            var canvas = els.workCanvas
            canvas.width = video.videoWidth
            canvas.height = video.videoHeight
            var ctx = canvas.getContext('2d')
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

            canvas.toBlob(
                function (blob) {
                    if (!blob) {
                        showError('Capture failed. Try again.')
                        return
                    }
                    setSourceBlob(blob)
                    stopCamera()
                    setStatus('Photo captured. Rotate if needed, then analyze.')
                },
                'image/jpeg',
                0.92
            )
        }

        function flipCamera() {
            state.facingMode = state.facingMode === 'user' ? 'environment' : 'user'
            startCamera()
        }

        /* ---------------- API binding ---------------- */

        function buildFormData(imageBlob, notes) {
            var formData = new FormData()
            formData.append('image', imageBlob, 'skin-capture.jpg')
            formData.append('browser_id', getBrowserId())
            formData.append('session_id', getSessionId())
            formData.append('rotation', String(state.rotation || 0))
            if (notes) formData.append('notes', notes)
            return formData
        }

        function analyzeJson(api, formData) {
            return fetch(api.baseUrl + '/api/v1/skin_analyses', {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + api.token,
                    Accept: 'application/json'
                },
                body: formData,
                credentials: 'omit'
            }).then(async function (response) {
                var data = null
                try {
                    data = await response.json()
                } catch (_e) {
                    data = null
                }

                if (!response.ok) {
                    var msg =
                        (data && (data.error || data.message)) ||
                        'Request failed (' + response.status + ')'
                    throw new Error(msg)
                }

                if (!data || data.success === false) {
                    throw new Error((data && data.error) || 'Analysis failed.')
                }

                return data
            })
        }

        async function analyzeStream(api, formData) {
            var response = await fetch(api.baseUrl + '/api/v1/skin_analyses/stream', {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + api.token,
                    Accept: 'text/event-stream'
                },
                body: formData,
                credentials: 'omit'
            })

            if (!response.ok || !response.body) {
                var text = await response.text()
                throw new Error(text || 'Stream request failed (' + response.status + ')')
            }

            if (els.output) els.output.textContent = ''

            var reader = response.body.getReader()
            var decoder = new TextDecoder()
            var buffer = ''
            var full = ''

            while (true) {
                var chunk = await reader.read()
                if (chunk.done) break

                buffer += decoder.decode(chunk.value, { stream: true })
                var parts = buffer.split('\n\n')
                buffer = parts.pop() || ''

                for (var i = 0; i < parts.length; i++) {
                    var line = parts[i].split('\n').find(function (entry) {
                        return entry.indexOf('data:') === 0
                    })
                    if (!line) continue

                    var payload = line.replace(/^data:\s*/, '').trim()
                    if (!payload) continue

                    var data
                    try {
                        data = JSON.parse(payload)
                    } catch (_e) {
                        continue
                    }

                    if (data.error) throw new Error(data.error)
                    if (data.content) {
                        full += data.content
                        if (els.output) els.output.textContent = full
                    }
                }
            }

            return { success: true, report: full }
        }

        function restoreLastReport() {
            try {
                var last = sessionStorage.getItem('skin_last_report')
                if (last && els.output) {
                    els.output.textContent = last
                    setStatus('Restored previous report for this session.')
                }
            } catch (_e) {}
        }

        /* ---------------- Analyze button ---------------- */

        if (els.analyzeBtn) {
            els.analyzeBtn.addEventListener('click', function (e) {
                e.preventDefault()
                clearError()

                if (!state.sourceBlob) {
                    showError('Please upload or capture a photo first.')
                    return
                }

                var api = getApiConfig()
                if (!api.baseUrl) {
                    showError('API URL is missing. Set it in the Skin Analysis section settings.')
                    return
                }
                if (!api.token) {
                    showError('API token is missing. Set it in the Skin Analysis section settings.')
                    return
                }

                els.analyzeBtn.disabled = true
                setStatus('Preparing image…')
                if (els.output) els.output.textContent = 'Analyzing…'

                getFinalImageBlob()
                    .then(function (finalBlob) {
                        window.__skinAnalysisLastBlob = finalBlob
                        setStatus(api.mode === 'stream' ? 'Streaming analysis…' : 'Sending to API…')
                        var formData = buildFormData(finalBlob, getNotes())
                        if (api.mode === 'stream') return analyzeStream(api, formData)
                        return analyzeJson(api, formData)
                    })
                    .then(function (result) {
                        var report = (result && result.report) || ''
                        if (els.output) els.output.textContent = report || 'No report returned.'

                        try {
                            sessionStorage.setItem('skin_last_report', report)
                            sessionStorage.setItem(
                                'skin_last_meta',
                                JSON.stringify({
                                    browser_id: getBrowserId(),
                                    session_id: getSessionId(),
                                    model: result && result.model,
                                    at: Date.now()
                                })
                            )
                        } catch (_e) {}

                        setStatus('Done')
                    })
                    .catch(function (err) {
                        console.warn('Skin analysis API failed', err)
                        showError(err.message || 'Analysis failed.')
                        setStatus('Failed')
                        if (els.output) {
                            els.output.textContent =
                                'Analysis failed. You can retry after fixing the error.'
                        }
                    })
                    .then(function () {
                        els.analyzeBtn.disabled = !state.sourceBlob
                    })
            })
        }

        /* ---------------- Events ---------------- */

        els.tabs.forEach(function (tab) {
            tab.addEventListener('click', function (e) {
                e.preventDefault()
                setMode(tab.getAttribute('data-mode-tab'))
            })
        })

        if (els.startCamera) {
            els.startCamera.addEventListener('click', function (e) {
                e.preventDefault()
                startCamera()
            })
        }
        if (els.cameraIdle && els.startCamera) {
            els.cameraIdle.addEventListener('click', function () {
                if (!els.startCamera.disabled) els.startCamera.click()
            })
        }
        if (els.capturePhoto) {
            els.capturePhoto.addEventListener('click', function (e) {
                e.preventDefault()
                captureFromVideo()
            })
        }
        if (els.flipCamera) {
            els.flipCamera.addEventListener('click', function (e) {
                e.preventDefault()
                flipCamera()
            })
        }
        if (els.stopCamera) {
            els.stopCamera.addEventListener('click', function (e) {
                e.preventDefault()
                stopCamera()
                setStatus('Camera stopped.')
            })
        }
        if (els.rotateLeft) {
            els.rotateLeft.addEventListener('click', function (e) {
                e.preventDefault()
                rotate(-90)
            })
        }
        if (els.rotateRight) {
            els.rotateRight.addEventListener('click', function (e) {
                e.preventDefault()
                rotate(90)
            })
        }
        if (els.clearImage) {
            els.clearImage.addEventListener('click', function (e) {
                e.preventDefault()
                clearImage()
            })
        }

        // Do not stop camera on visibilitychange (permission dialogs can abort it)
        window.addEventListener('pagehide', stopCamera)

        /* ---------------- Init ---------------- */

        saveRotation()
        setCameraControls(false)
        restoreLastReport()

        window.SkinAnalysisCapture = {
            getFinalImageBlob: getFinalImageBlob,
            getRotation: function () {
                return state.rotation
            },
            getBrowserId: getBrowserId,
            getSessionId: getSessionId,
            hasImage: function () {
                return !!state.sourceBlob
            }
        }
    })
})()